module.exports = __webpack_public_path__ + "static/media/creativesDesktop.6043106c.png";